document.addEventListener("DOMContentLoaded", function () {
  // Select all arrow elements with the class 'icon-arrow-right'
  var menuArrows = document.querySelectorAll('.icon-arrow-right');

  menuArrows.forEach(function (arrow) {
    arrow.addEventListener('click', function () {
      arrow.classList.toggle('active'); // Toggle the 'active' class on click
    });
  });
});


